export default import.meta.ROLLUP_FILE_URL_HFnSo_t2ji54Ii8fKeJyow;